import React, { Suspense, lazy } from 'react';
import BuildIcon from '@mui/icons-material/Build'
import { Loading } from 'react-admin';

const ReportParameterList = lazy(() => import('./ReportParamList'));
const ReportParameterCreate = lazy(() => import('./ReportParamCreate'));
const ReportParameterEdit = lazy(() => import('./ReportParamEdit'));
const ReportParameterShow = lazy(() => import('./ReportParamShow'));

const ReportParameterConfig = {
  list: (props) => (
    <Suspense fallback={<Loading />}>
      <ReportParameterList {...props} />
    </Suspense>
  ),
  create: (props) => (
    <Suspense fallback={<Loading />}>
      <ReportParameterCreate {...props} />
    </Suspense>
  ),
  edit: (props) => (
    <Suspense fallback={<Loading />}>
      <ReportParameterEdit {...props} />
    </Suspense>
  ),
  show: (props) => (
    <Suspense fallback={<Loading />}>
      <ReportParameterShow {...props} />
    </Suspense>
  ),
  icon: <BuildIcon />
};

export default ReportParameterConfig;